import { LocationNumbersStoreModule } from "../../../types/LocationNumbers"

const state = {
  agencyTwilio: {
    id: '',
    accountSid: '',
    companyId: '',
    traceId: '',
  },
  callerIDs: [],
  defaultOutboundNumber: '',
  loading: false,
  locationId: '',
  locationTwilio: {},
  mapPhoneNumberSID: {},
  modalLoading: false,
  numberPoolIDs: [],
  numberPools: [],
  numberPoolsIdIndexLookup: {},
  phoneNumbers: [],
  phoneNumbersSIDIndexLookup: {},
  phoneNumbersA2PLookup: {},
  renderedRecordsCount: 0,
  stripe: {},
  totalNumberPools: 0,
  totalPhoneNumbers: 0,
  totalVerifiedCallerIDs: 0,
  tollFreeStatus: {},
  tollFreeStatusTracker: "",
  table: {
    searchText: '',
    currentPage: 1,
    totalPages: 0,
    limit: 10,
  },
  a2pComplianceStatus: '',
  phoneNumbersSID: {},
} as LocationNumbersStoreModule

export default state
